import { CompaniesView } from "../Views";

export const CompaniesPage = (props: { location: any }) => {
	return <CompaniesView location={props.location} />;
};
